
import { Component, Vue } from 'vue-property-decorator';
import DeviceData from '~/components/Data.vue';
import DeletePlantComponent from '~/components/Eliot/DeletePlantComponent.vue';
import Topology from '~/components/Eliot/Topology.vue';
import Users from '~/components/Eliot/Users.vue';
import Module from '~/components/Module.vue';
import { EliotModule } from '~/store/modules/eliot';

@Component({
    components: {
        Module,
        DeviceData,
        Topology,
        Users,
        DeletePlantComponent,
    },
})
export default class ELiotLayout extends Vue {

    get plantData() {
        return EliotModule.plantSpecFields;
    }
    get plantId() {
        return EliotModule.currentPlantId;
    }

    get plantName() {
        return EliotModule.currentPlant?.name;
    }

    get eliotGatewayId() {
        return EliotModule.currentGatewayId;
    }

    get networkData() {
        return EliotModule.plantNetworkFields;
    }

    allowedUsers(plantId: string) {
        return EliotModule.allowedUsers(plantId);
    }

    invitedUsers(plantId: string) {
        return EliotModule.invitedUsers(plantId);
    }
}
